import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type TextCheckboxProps = {
    checked: boolean;
    id: string;
    label: string | undefined;
    containerClassName?: string;
    labelClassName?: string;
    inputClassName?: string;
    readOnly: boolean;
    tooltip?: string;
    onChange: (checked: boolean) => void;
    onLabelClick?: () => void;
};

function LabelCheckbox(props: TextCheckboxProps) {
    const inputClassName = `form-check-input me-1 ${props.readOnly ? "read-only-check" : ""} ${props.inputClassName}`;

    return (
        <div className={`text-nowrap ${props.containerClassName}`}>
            {props.tooltip ? (
                <OverlayTrigger overlay={<Tooltip>{props.tooltip}</Tooltip>} delay={100}>
                    <i className="fas fa-circle-info me-1"></i>
                </OverlayTrigger>
            ) : null}
            <input
                id={props.id}
                type="checkbox"
                className={inputClassName}
                checked={props.checked}
                onChange={(e) => props.onChange(e.target.checked)}
                readOnly={props.readOnly}
            />
            <label
                htmlFor={props.id}
                onClick={() => (!props.readOnly && props.onLabelClick ? props.onLabelClick() : false)}
                className={`d-inline form-check-label ${props.labelClassName ?? ""} ${props.readOnly ? "pe-none" : ""}`}
            >
                {props.label}
            </label>
        </div>
    );
}

export default LabelCheckbox;
